
import { Component, Mixins } from "vue-property-decorator";
import { IBarcodeCscanSetPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { IBarcodeCscanSetSpecification } from "../../../../../domain/editableFormat/IFormatSpecification";
import { CommonComponentsContainer } from "../../contents";
import { BarcodeStylePropertyEditableMixin, BarcodeItemPropertyEditableMixin } from "./";

@Component
export default class BarcodeCscanSetPropertyEditableMixin extends Mixins(BarcodeStylePropertyEditableMixin, BarcodeItemPropertyEditableMixin) {
  writePropertyWhenValid: (writer: (source: IBarcodeCscanSetPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IBarcodeCscanSetPropertyEditable) => T, defaultValue: T) => T;

  getCommonComponents: () => CommonComponentsContainer;

  get isBarcodeCscanSetPropertyEditable(): boolean {
    return this.isBarcodeStylePropertyEditable && this.isBarcodeItemsPropertyEditable;
  }

  get selectableBarcodeCscanSets(): IBarcodeCscanSetSpecification[] {
    return this.readPropertyOrDefault(s => s.getSelectableCscanSets(), []);
  }

  async selectCscanSetting() {
    try {
      // 名称かデータ項目があった場合、ダイアログ上書きして良いか確認。
      if (this.barcodeItems.length > 0 || !!this.readPropertyOrDefault(s => s.name().getValue(), "")) {
        const index = await this.$commonDialogs.confirmation.confirmYesNo(
          "C-Scan連携設定による上書き確認",
          ["既に名称もしくはバーコード項目が設定済です。設定するとそれらは上書きされますがよろしいですか？"]
        );
        if (index !== 0) { return; }
      }
      const dialog = this.getCommonComponents().getDialogs().getCscanSettingSelectDialog();
      const set = await dialog.show(this.selectableBarcodeCscanSets);
      if (!set) { return; }
      this.writePropertyWhenValid(s => {
        s.name().setValue("C-Scan連携");
        s.barcodeStyle().setValue(set.style);
        s.barcodeItems().setValue(set.items);
      });
    } catch {}
  }
}
